module.exports = __webpack_public_path__ + "img/LT.58a78ade.svg";